import { ISingleIdParams } from '../types/actionParams';
import { TableAllowedActions } from '../types/TableAllowedActions';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class GetTableActionsRequest extends Request<ISingleIdParams, TableAllowedActions> {
  constructor(id: string) {
    super('getTableActions', { id: id });
  }
}
